import { TemplateElement, defineElement, html } from '@webtides/element-js';

export default class Spinner extends TemplateElement {
    template() {
        return html`
            <svg
                class="animate-spin"
                xmlns="http://www.w3.org/2000/svg"
                width="74"
                height="74"
                viewBox="0 0 74 74"
                fill="none"
            >
                <mask id="path-1-inside-1_228_14245" fill="white">
                    <path
                        d="M74 37C74 57.4345 57.4345 74 37 74C16.5655 74 0 57.4345 0 37C0 16.5655 16.5655 0 37 0C57.4345 0 74 16.5655 74 37Z"
                    />
                </mask>
                <g
                    clip-path="url(#paint0_angular_228_14245_clip_path)"
                    data-figma-skip-parse="true"
                    mask="url(#path-1-inside-1_228_14245)"
                >
                    <g transform="matrix(0 0.037 -0.037 0 37 37)">
                        <foreignObject x="-1243.24" y="-1243.24" width="2486.49" height="2486.49"
                            ><div
                                xmlns="http://www.w3.org/1999/xhtml"
                                style="background:conic-gradient(from 90deg,rgba(255, 255, 255, 1) 0deg,rgba(251, 251, 251, 1) 180deg,rgba(255, 140, 40, 1) 270deg,rgba(215, 1, 126, 1) 360deg);height:100%;width:100%;opacity:1"
                            ></div
                        ></foreignObject>
                    </g>
                </g>
                <path
                    d="M74 37H65C65 52.464 52.464 65 37 65V74V83C62.4051 83 83 62.4051 83 37H74ZM37 74V65C21.536 65 9 52.464 9 37H0H-9C-9 62.4051 11.5949 83 37 83V74ZM0 37H9C9 21.536 21.536 9 37 9V0V-9C11.5949 -9 -9 11.5949 -9 37H0ZM37 0V9C52.464 9 65 21.536 65 37H74H83C83 11.5949 62.4051 -9 37 -9V0Z"
                    data-figma-gradient-fill='{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.0},{"color":{"r":0.98750001192092896,"g":0.98750001192092896,"b":0.98750001192092896,"a":1.0},"position":0.50},{"color":{"r":1.0,"g":0.54901963472366333,"b":0.15686275064945221,"a":1.0},"position":0.750},{"color":{"r":0.84313726425170898,"g":0.0039215688593685627,"b":0.49411764740943909,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.0},{"color":{"r":0.98750001192092896,"g":0.98750001192092896,"b":0.98750001192092896,"a":1.0},"position":0.50},{"color":{"r":1.0,"g":0.54901963472366333,"b":0.15686275064945221,"a":1.0},"position":0.750},{"color":{"r":0.84313726425170898,"g":0.0039215688593685627,"b":0.49411764740943909,"a":1.0},"position":1.0}],"transform":{"m00":4.5311934339744599e-15,"m01":-74.0,"m02":74.0,"m10":74.0,"m11":4.5311934339744599e-15,"m12":-4.5311934339744599e-15},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
                    mask="url(#path-1-inside-1_228_14245)"
                />
                <defs>
                    <clipPath id="paint0_angular_228_14245_clip_path">
                        <path
                            d="M74 37H65C65 52.464 52.464 65 37 65V74V83C62.4051 83 83 62.4051 83 37H74ZM37 74V65C21.536 65 9 52.464 9 37H0H-9C-9 62.4051 11.5949 83 37 83V74ZM0 37H9C9 21.536 21.536 9 37 9V0V-9C11.5949 -9 -9 11.5949 -9 37H0ZM37 0V9C52.464 9 65 21.536 65 37H74H83C83 11.5949 62.4051 -9 37 -9V0Z"
                            mask="url(#path-1-inside-1_228_14245)"
                        />
                    </clipPath>
                </defs>
            </svg>
        `;
    }
}

defineElement('mb-spinner', Spinner);
